import { render, staticRenderFns } from "./base-comp.vue?vue&type=template&id=1728d308&scoped=true&"
import script from "./base-comp.vue?vue&type=script&lang=js&"
export * from "./base-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728d308",
  null
  
)

export default component.exports